module.exports = __webpack_public_path__ + "static/assets/8976ee64ef97be664426fa51a779489b.gif";